import { type FC } from "react";
import { type AchievementProps } from "@legacy_user_frontend/components/pages/mypage/profiles/profiles_show/src/profile_show_props";
import { EditPageLink } from "./edit_page_link";
import * as styles from "../styles.css";

export const AchievementCassette: FC<AchievementProps> = ({ achievement, editAchievementPath }) => (
  <>
    {achievement.achievements.length > 0 && (
      <ul className={styles.innerCassetteList}>
        {achievement.achievements.map(({ name, year, month }, index) => (
          <li key={name}>
            <section className={styles.innerCassette}>
              <div className={styles.innerCassetteHeadingOuter}>
                <h4 className={styles.innerCassetteHeading}>
                  <span>受賞・表彰歴{index + 1}</span>
                  <EditPageLink url={`${editAchievementPath}#cassette-${index}`} />
                </h4>
              </div>
              <div className={styles.innerCassetteContent}>
                <div className={styles.tableList}>
                  <dt>受賞した賞の名前</dt>
                  <dd>{name}</dd>
                  {year && (
                    <>
                      <dt>年月</dt>
                      <dd>
                        {year}年{month && ` ${month}月`}
                      </dd>
                    </>
                  )}
                </div>
              </div>
            </section>
          </li>
        ))}
      </ul>
    )}
  </>
);
